import $ from 'jquery'
import {map} from 'lodash'
Select2Mixin =
  template: JST['mixins/select2']()
  props: [
    'name', 'collection', 'multiple', 'value',
    'id', 'includeBlank', 'allowClear', 'tags'
  ]
  mounted: ->
    vm = this
    @jQueryEl.select2(@selectOptions()).on('change', -> vm.updateValue(this))
    if @value
      @jQueryEl.val(@value)
    @jQueryEl.trigger("change")

  updated: ->
    @jQueryEl.val(@value)
    @jQueryEl.trigger('change')

  computed:
    jQueryEl: ->
      $(@$el)
    isMultiple: ->
      @multiple || false

  methods:
    updateValue: (select)->
      if select.length > 0
        @$emit('input', $(select).val())
    selectOptions: ->
      allowClear = if @allowClear == undefined then true else @allowClear
      opts =
        allowClear: allowClear
        dropdownAutoWidth: true
        theme: 'bootstrap'
        width: @width || '100%'
        tags: @tags || false
        tokenSeparators: @separators
        placeholder: @placeholder || ''
        data: if Array.isArray(@value)
                @value.map((option) -> { id: option[1], text: option[0] })
              else
                []

      opts

export default Select2Mixin